/* eslint-disable no-else-return */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import DOMPurify from 'dompurify';
import Linkify from 'react-linkify';
import HeaderThumbnail from './HeaderThumbnail';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import { makeBannerBackgroundStyle } from '../../../../../shared/utils/StylingUtils';
import { attachCloudinaryOptionsToImageSource } from '../../../../../shared/utils/ImageUtils';

export default class GroupHeaderWidget extends PureComponent {
    static propTypes = {
        currentGroupId: PropTypes.string,
        loading: PropTypes.bool,
        collection: PropTypes.object,
        buttonProps: PropTypes.object,
        showButton: PropTypes.bool,
        secondaryInfoComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        secondaryInfoComponentProps: PropTypes.object,
        titleComponent: PropTypes.object,
        className: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        thumbnailImageUrl: PropTypes.string,
        whiteLabelColors: PropTypes.shape({
            navigationPrimaryBackground: PropTypes.string
        })
    };

    // eslint-disable-next-line consistent-return
    _makeBannerImageProps = (collection = {}) => {
        if (collection.coverImageUrl) {
            const backgroundUrl = attachCloudinaryOptionsToImageSource(collection.coverImageUrl, {
                color: '000000',
                colorize: 40
            });
            const result = makeBannerBackgroundStyle(backgroundUrl);
            return result;
        }
    };

    renderButton = (hiddenClass) => {
        const { buttonProps = {} } = this.props;
        return (
            <VerbButton
                className={`col-12 col-md-6 col-lg-5 ${hiddenClass}`}
                buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                onClick={buttonProps.onClick}
                disabled={buttonProps.disabled}
            >
                {buttonProps.buttonText}
            </VerbButton>
        );
    };

    render() {
        const {
            currentGroupId,
            loading,
            showButton = false,
            collection,
            secondaryInfoComponent,
            secondaryInfoComponentProps = {},
            titleComponent = null,
            className = '',
            thumbnailImageUrl,
            title = '',
            description
        } = this.props;

        const backgroundBannerStyle = this._makeBannerImageProps(collection);

        return (
            <div style={backgroundBannerStyle} className={cns(`col-12 group-header header-container`, className)}>
                <div className={'container'}>
                    <div className={'row align-items-center'}>
                        <div className={'col-12 col-md-9'}>
                            <div className={'row'}>
                                <div className={'col-sm-12 header-containing-container'}>
                                    <div className={'header-thumbnail col-6 col-sm-5 col-lg-4'}>
                                        <HeaderThumbnail
                                            id={currentGroupId}
                                            name={title}
                                            thumbnailImageUrl={thumbnailImageUrl}
                                            className={cns({ loading: loading && !title })}
                                        />
                                    </div>
                                    <div className={'col-6 col-sm-7'} style={{ padding: '0 10px' }}>
                                        <div className={cns('group-info row', { loading })}>
                                            {titleComponent || (
                                                <span
                                                    className={'group-name header-collection-name'}
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(`<div>${title}</div>`)
                                                    }}
                                                />
                                            )}
                                            <div
                                                className={cns('group-description col-12', {
                                                    loading: loading && !title
                                                })}
                                            >
                                                <Linkify properties={{ target: '_blank' }}>{description}</Linkify>
                                            </div>
                                        </div>
                                        {!!secondaryInfoComponent && (
                                            <div className={'col-12 group-header-info-secondary stats-small-display'}>
                                                {secondaryInfoComponent(secondaryInfoComponentProps)}
                                            </div>
                                        )}
                                        {showButton && this.renderButton('hidden-xs group-header-button')}
                                    </div>
                                </div>
                            </div>
                            {showButton && (
                                <div className={'header-mobile-cta-button visible-xs col-12'}>
                                    {this.renderButton('visible-xs')}
                                </div>
                            )}
                        </div>
                        {!!secondaryInfoComponent && (
                            <div className={'col-12 col-sm-3 group-header-info-secondary stats-normal-display'}>
                                {secondaryInfoComponent(secondaryInfoComponentProps)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
